import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

export const StCarouselFooter = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  marginTop: '1rem',
});

export const StShowingOfText = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral7?.main || '#595959',
  fontSize: '14px',
  lineHeight: 1.4,
  textAlign: 'center',
}));

export const StCarouselIndicators = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

interface StCarouselIndicatorProps {
  active?: boolean;
}

export const StCarouselIndicator = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<StCarouselIndicatorProps>(({ theme, active }) => ({
  padding: '2px',
  color: active ? theme.palette.primary.main : theme.palette.neutral4?.main,
}));
